import { Avatar, Box, Grid, Link, Text } from '@factorialco/deprecated-design-system'
import { PurchaseRequestFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { buildUrl } from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import InfoItem from 'modules/procurement/components/InfoItem'

interface Props {
  purchaseRequest: PurchaseRequestFragment
}

const GeneralInfo = ({ purchaseRequest }: Props) => {
  const {
    access: { locale },
  } = useCurrentSession()
  return (
    <Box gap="s2">
      <Grid variant="fixed">
        {purchaseRequest.additionalInformation && (
          <Box gridColSpan={{ xxs: 12 }}>
            <InfoItem
              label={i18n.t('procurement.purchase_requests.detail.info.description')}
              textItem={purchaseRequest.additionalInformation}
            />
          </Box>
        )}
        <Box gridColSpan={{ xxs: 6 }}>
          <InfoItem
            label={i18n.t('procurement.purchase_requests.detail.info.employee')}
            item={
              <Box flexDirection="row" alignItems="center" gap="s8">
                <Avatar
                  size="s40"
                  url={buildUrl(purchaseRequest.requesterEmployee?.avatar?.url)}
                  label={purchaseRequest.requesterEmployee?.fullName || ''}
                />
                <Text.Normal size="200" weight="medium" color="grey1000">
                  {purchaseRequest.requesterEmployee?.fullName || ''}
                </Text.Normal>
              </Box>
            }
          />
        </Box>
        <Box gridColSpan={{ xxs: 12 }}>
          <InfoItem
            label={i18n.t('procurement.purchase_requests.detail.info.cost')}
            item={
              purchaseRequest.cost && (
                <Text weight="medium" size="200" color="grey1000">
                  {MoneyWithCurrency({
                    amount: Number(purchaseRequest.cost.cents),
                    currency: purchaseRequest.cost.currency,
                    locale,
                  })}
                </Text>
              )
            }
          />
        </Box>
        {purchaseRequest.url && (
          <Box gridColSpan={{ xxs: 12 }}>
            <InfoItem
              label={i18n.t('procurement.purchase_requests.detail.info.url')}
              item={
                <Link.Href href={purchaseRequest.url} target="_blank">
                  {purchaseRequest.url}
                </Link.Href>
              }
            />
          </Box>
        )}
      </Grid>
    </Box>
  )
}

export default GeneralInfo
